import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Form,
  FormGroup,
  FormField,
  Checkbox,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardBillingEncountersUX = (props: any) => {
    return(
      <div
        id="CardBillingEncountersUX-div-0">
        <div
          id="CardBillingEncountersUX-div-24"
          style={{fontWeight: "bold", fontSize: "1.2rem",padding: "10px 10px 0px 10px", display: "flex", justifyContent: "space-between"}}>
          {props.languageUX === "en" ? "List of command and service status" : "รายการสถานะคำสั่งและบริการ"}
          <div
            id="CardBillingEncountersUX-div-72">

          </div>
        </div>
        <div
          id="CardBillingEncountersUX-div-87"
          style={{ padding: "0px 10px 10px 10px"}}>

          <hr
            id="CardBillingEncountersUX-hr-88">
          </hr>
        </div>
        <Table
          data={props.encounterListData}
          headers="Encounter,แผนกที่รับบริการ,แพทย์เจ้าของไข้,สถานะการรับบริการ,วันและเวลาที่เข้ารับบริการ,วันและเวลาที่อัปเดตล่าสุด"
          id="CardBillingEncountersUX-Table-26"
          keys="number,division_name,doctor_name,status_name,created,edited"
          minRows={1}
          showPagination={false}
          style={{height: "150px", margin: "0px 10px"}}>
        </Table>
        <div
          id="CardBillingEncountersUX-div-63"
          style={{paddingTop: "30px" }}>

          <Form
            className="size small"
            id="CardBillingEncountersUX-Form-91">
            <FormGroup
              id="CardBillingEncountersUX-FormGroup-92"
              inline={true}
              style={{marginLeft: "10px"}}>
              <FormField
                id="CardBillingEncountersUX-FormField-93"
                inline={true}
                style={{minWidth: "max-content"}}>

                <Checkbox
                  checked={props.filterDrOrder?.isOrderName ?? false}
                  id="CardBillingEncountersUX-Checkbox-104"
                  label="ชื่อคำสั่ง"
                  name="isOrderName"
                  onChange={props.onChangeFilter}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardBillingEncountersUX-FormField-94"
                inline={true}
                width={3}>
                <Dropdown
                  className="inline-label"
                  disabled={!props.filterDrOrder?.isOrderName}
                  fluid={true}
                  id="CardBillingEncountersUX-Dropdown-105"
                  name="order_name"
                  onChange={props.onChangeFilter}
                  options={props.drOrderSubclassOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterDrOrder?.order_name ?? ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardBillingEncountersUX-FormField-95"
                inline={true}
                style={{minWidth: "max-content"}}>
                <Checkbox
                  checked={props.filterDrOrder?.isDate ?? false}
                  id="CardBillingEncountersUX-Checkbox-106"
                  label="วันที่สั่ง"
                  name="isDate"
                  onChange={props.onChangeFilter}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardBillingEncountersUX-FormField-96"
                inline={true}
                style={{minWidth: "9.5rem"}}
                width={3}>
                <div
                  id="CardBillingEncountersUX-div-110"
                  style={{width: "100%"}}>

                  <DateTextBox
                    disabled={!props.filterDrOrder?.isDate }
                    id="CardBillingEncountersUX-DateTextBox-111"
                    onChange={(value: any)=>props.onChangeFilter?.(null,{name:"start_date", value})}
                    value={props.filterDrOrder?.start_date}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardBillingEncountersUX-FormField-97"
                inline={true}>
                <label
                  id="CardBillingEncountersUX-label-108"
                  style={{fontWeight: "normal"}}>
                  ถึง
                </label>
              </FormField>
              <FormField
                id="CardBillingEncountersUX-FormField-98"
                inline={true}
                style={{minWidth: "9.5rem"}}
                width={3}>
                <div
                  id="CardBillingEncountersUX-div-109"
                  style={{width: "100%"}}>

                  <DateTextBox
                    disabled={!props.filterDrOrder?.isDate }
                    id="CardBillingEncountersUX-DateTextBox-112"
                    onChange={(value: any)=>props.onChangeFilter?.(null,{name:"end_date", value})}
                    value={props.filterDrOrder?.end_date}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardBillingEncountersUX-FormField-99"
                inline={true}
                style={{minWidth: "max-content"}}>
                <Checkbox
                  checked={props.filterDrOrder?.isPaymentStatus ?? false}
                  id="CardBillingEncountersUX-Checkbox-113"
                  label="สถานะชำระเงิน"
                  name="isPaymentStatus"
                  onChange={props.onChangeFilter}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardBillingEncountersUX-FormField-100"
                inline={true}
                width={3}>
                <Dropdown
                  className="inline-label"
                  disabled={!props.filterDrOrder?.isPaymentStatus}
                  fluid={true}
                  id="CardBillingEncountersUX-Dropdown-114"
                  name="payment_status"
                  onChange={props.onChangeFilter}
                  options={props.paymentStatusOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterDrOrder?.payment_status ?? ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardBillingEncountersUX-FormField-101"
                inline={true}
                style={{minWidth: "max-content"}}>
                <Checkbox
                  checked={props.filterDrOrder?.isOrderStatus ?? false}
                  id="CardBillingEncountersUX-Checkbox-115"
                  label="สถานะคำสั่ง"
                  name="isOrderStatus"
                  onChange={props.onChangeFilter}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardBillingEncountersUX-FormField-102"
                inline={true}
                width={3}>
                <Dropdown
                  className="inline-label"
                  disabled={!props.filterDrOrder?.isOrderStatus}
                  fluid={true}
                  id="CardBillingEncountersUX-Dropdown-116"
                  name="order_status"
                  onChange={props.onChangeFilter}
                  options={props.statusOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterDrOrder?.order_status ?? ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardBillingEncountersUX-FormField-103"
                inline={true}>
                <div
                  id="CardBillingEncountersUX-div-117">
                  {props.buttonSearch}
                </div>
              </FormField>
            </FormGroup>
          </Form>
          <Table
            data={props.doctorOrderData}
            headers="ชื่อคำสั่ง,วันที่และเวลาสั่ง Order,สถานะการชำระเงิน,สถานะคำสั่ง,ข้อความ,หมายเหตุ"
            id="CardBillingEncountersUX-Table-2"
            keys="name,order_time,payment_status_name,order_status_name,message,note"
            minRows={8}
            showPagination={false}
            style={{height: "350px",  margin: "0px 10px"}}>
          </Table>
          <div
            id="CardBillingEncountersUX-div-89"
            style={{display:"flex", margin:"10px ", justifyContent: "space-between"}}>

            <div>
              {props.buttonRefresh}
            </div>
            <div>
              {props.pagination}
            </div>
          </div>
        </div>
        <div
          id="CardBillingEncountersUX-div-65"
          style={{width: "100%", height: "200px", display: "none"}}>

        </div>
      </div>
    )
}


export default CardBillingEncountersUX

export const screenPropsDefault = {"debug":true,"showSupplyList":false}

/* Date Time : Thu Aug 28 2025 17:11:10 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-div-0"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 0
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 2,
      "name": "Table",
      "parent": 63,
      "props": {
        "columns": {
          "type": "code",
          "value": ""
        },
        "data": {
          "type": "code",
          "value": "props.doctorOrderData"
        },
        "getTdProps": {
          "type": "code",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": "ชื่อคำสั่ง,วันที่และเวลาสั่ง Order,สถานะการชำระเงิน,สถานะคำสั่ง,ข้อความ,หมายเหตุ"
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-Table-2"
        },
        "keys": {
          "type": "value",
          "value": "name,order_time,payment_status_name,order_status_name,message,note"
        },
        "minRows": {
          "type": "code",
          "value": "8"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"350px\",  margin: \"0px 10px\"}"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการสถานะคำสั่งและบริการ",
          "valueEN": "List of command and service status"
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\",padding: \"10px 10px 0px 10px\", display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 26,
      "name": "Table",
      "parent": 0,
      "props": {
        "data": {
          "type": "code",
          "value": "props.encounterListData"
        },
        "getTdProps": {
          "type": "code",
          "value": ""
        },
        "getTrProps": {
          "type": "code",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": "Encounter,แผนกที่รับบริการ,แพทย์เจ้าของไข้,สถานะการรับบริการ,วันและเวลาที่เข้ารับบริการ,วันและเวลาที่อัปเดตล่าสุด"
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-Table-26"
        },
        "keys": {
          "type": "value",
          "value": "number,division_name,doctor_name,status_name,created,edited"
        },
        "minRows": {
          "type": "code",
          "value": "1"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"150px\", margin: \"0px 10px\"}"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"30px\" }"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"200px\", display: \"none\"}"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-div-72"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0px 10px 10px 10px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "hr",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-hr-88"
        }
      },
      "seq": 88,
      "void": true
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", margin:\"10px \", justifyContent: \"space-between\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "Form",
      "parent": 63,
      "props": {
        "className": {
          "type": "value",
          "value": "size small"
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-Form-91"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "FormGroup",
      "parent": 91,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-FormGroup-92"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "FormField",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-FormField-93"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-FormField-94"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-FormField-95"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-FormField-96"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"9.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-FormField-97"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-FormField-98"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"9.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-FormField-99"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-FormField-100"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-FormField-101"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-FormField-102"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-FormField-103"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "Checkbox",
      "parent": 93,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterDrOrder?.isOrderName ?? false"
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-Checkbox-104"
        },
        "label": {
          "type": "value",
          "value": "ชื่อคำสั่ง"
        },
        "name": {
          "type": "value",
          "value": "isOrderName"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Dropdown",
      "parent": 94,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.filterDrOrder?.isOrderName"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-Dropdown-105"
        },
        "name": {
          "type": "value",
          "value": "order_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.drOrderSubclassOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterDrOrder?.order_name ?? \"\""
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "Checkbox",
      "parent": 95,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterDrOrder?.isDate ?? false"
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-Checkbox-106"
        },
        "label": {
          "type": "value",
          "value": "วันที่สั่ง"
        },
        "name": {
          "type": "value",
          "value": "isDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "label",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง"
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-label-108"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "div",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-div-109"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-div-110"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 111,
      "name": "DateTextBox",
      "parent": 110,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.filterDrOrder?.isDate "
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-DateTextBox-111"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeFilter?.(null,{name:\"start_date\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.filterDrOrder?.start_date"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 112,
      "name": "DateTextBox",
      "parent": 109,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.filterDrOrder?.isDate "
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-DateTextBox-112"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeFilter?.(null,{name:\"end_date\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.filterDrOrder?.end_date"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Checkbox",
      "parent": 99,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterDrOrder?.isPaymentStatus ?? false"
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-Checkbox-113"
        },
        "label": {
          "type": "value",
          "value": "สถานะชำระเงิน"
        },
        "name": {
          "type": "value",
          "value": "isPaymentStatus"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "Dropdown",
      "parent": 100,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.filterDrOrder?.isPaymentStatus"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-Dropdown-114"
        },
        "name": {
          "type": "value",
          "value": "payment_status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.paymentStatusOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterDrOrder?.payment_status ?? \"\""
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "Checkbox",
      "parent": 101,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterDrOrder?.isOrderStatus ?? false"
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-Checkbox-115"
        },
        "label": {
          "type": "value",
          "value": "สถานะคำสั่ง"
        },
        "name": {
          "type": "value",
          "value": "isOrderStatus"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "Dropdown",
      "parent": 102,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.filterDrOrder?.isOrderStatus"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-Dropdown-116"
        },
        "name": {
          "type": "value",
          "value": "order_status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.statusOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterDrOrder?.order_status ?? \"\""
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardBillingEncountersUX-div-117"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonRefresh"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        }
      },
      "seq": 119,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardBillingEncountersUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "debug": true,
    "showSupplyList": false
  },
  "width": 80
}

*********************************************************************************** */
